import { Entity, EntityMap, YammerState } from '../state/types';

const getEntities = <T extends Entity>(state: YammerState, bucket: keyof YammerState) => {
  const entities = state[bucket] as EntityMap<T>;

  if (!entities) {
    throw new Error(`Can not get entities in '${bucket}'`);
  }

  return entities.fulfilled.byId;
};

type FindById<T extends Entity> = (state: YammerState, id: Entity['id']) => T | undefined;

type CreateFindById = <T extends Entity>(bucket: keyof YammerState) => FindById<T>;
export const createFindById: CreateFindById =
  <T extends Entity>(bucket: keyof YammerState) =>
  (state, id) => {
    const entity = getEntities<T>(state, bucket)[id];
    if (!entity) {
      return;
    }

    return entity;
  };

type FindByIdThrows<T extends Entity> = (state: YammerState, id: Entity['id']) => T;

type CreateFindByIdThrows = <T extends Entity>(bucket: keyof YammerState) => FindByIdThrows<T>;
export const createFindByIdThrows: CreateFindByIdThrows =
  <T extends Entity>(bucket: keyof YammerState) =>
  (state, id) => {
    const entity = getEntities<T>(state, bucket)[id];
    if (!entity) {
      throw new Error(`Can not find entity '${id}' in bucket [${bucket}]`);
    }

    return entity;
  };
